import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from './Util/Session/session.service';
import { environment } from '../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransferOrderService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
   }

  GetDataOnComboLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetDataOnCombo/BoxLoad`,
      this.session.SetClass(Detail))
      .pipe(map(response => {
        return response;
      }))
  }

  SaveTransferOrder(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ALLOTMENTTRANSACTION_INSERT/Update`,
      this.session.SetClass(Detail))
      .pipe(map(response => {
        return response;
      }))
  }

  TransferOrderPrint(Detail: any) {
    return this.http.post<any>(environment.API_URL + `TransferOrder`,
      this.session.SetClass(Detail))
      .pipe(map(response => {
        return response;
      }))
  }
}
